var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown"},[_c('div',{staticClass:"dropdown-content"},_vm._l((_vm.status.options),function(option){return _c('p',{key:option.value,staticClass:"option cursor-pointer py-2 m-0",class:{
        'border-top': option.value === 'CANCEL' && _vm.status.options.length > 1,
        'border-bottom':
          option.value === 'ย้อนกลับ' && _vm.status.options.length > 1,
      },on:{"click":function($event){return _vm.onStatusClick(option)}}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }